import BackspaceRoundedIcon from "@mui/icons-material/BackspaceRounded"
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material"
import { useAppDispatch } from "../../../hooks/useRedux"
import { clearAndKeepHistory } from "../../../store/slices/editor.slice"

interface Props {
    label: string
    onClick: () => void
    disabled: boolean
}

function ClearScene({ label, onClick, disabled }: Props) {
    const dispatch = useAppDispatch()

    const handleClear = () => {
        onClick()
        dispatch(clearAndKeepHistory())
    }

    return (
        <MenuItem key="clear" onClick={handleClear} disabled={disabled}>
            <ListItemIcon sx={{ color: "error.main" }}>
                <BackspaceRoundedIcon />
            </ListItemIcon>
            <ListItemText sx={{ color: "error.main" }}>{label}</ListItemText>
        </MenuItem>
    )
}

export default ClearScene
